import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, Star } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center px-4 py-12 md:py-20 overflow-hidden bg-forest-800" data-id="element-34">
      {/* Background Glow */}
      <div className="absolute inset-0 bg-radial-glow opacity-60 pointer-events-none" data-id="element-35" />

      {/* Decorative botanical elements (CSS shapes) */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-forest-500 rounded-full blur-[100px] opacity-20 -translate-x-1/2 -translate-y-1/2" data-id="element-36" />
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-gold-500 rounded-full blur-[120px] opacity-10 translate-x-1/3 translate-y-1/3" data-id="element-37" />

      <div className="relative z-10 max-w-6xl mx-auto w-full flex flex-col lg:flex-row items-center gap-8 lg:gap-16" data-id="element-38">
        {/* Text Content */}
        <div className="flex-1 text-center lg:text-left space-y-5 md:space-y-8" data-id="element-39">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-gold-500/30 bg-forest-700/50 backdrop-blur-sm" data-id="element-40">
            <div className="flex -space-x-1" data-id="element-41">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-3 h-3 text-gold-500 fill-gold-500" data-id="element-42" />)}
            </div>
            <span className="text-xs font-medium text-gold-400 uppercase tracking-wider" data-id="element-43">
              Método Tradicional Mexicano
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="text-4xl md:text-5xl lg:text-7xl font-serif font-bold text-gold-500 leading-tight" data-id="element-44">
            Plantas Mexicanas para{' '}
            <span className="text-cream-100 italic" data-id="element-45">Dormir Profundo</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="text-xl md:text-2xl text-cream-200 font-serif" data-id="element-46">
            Duerme 8 Horas Sin Pastillas del Mercado Sonora
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} className="p-4 md:p-6 bg-forest-700/50 border-l-4 border-gold-500 rounded-r-lg backdrop-blur-sm" data-id="element-47">
            <p className="text-lg md:text-xl text-cream-300 italic font-serif" data-id="element-48">
              "3 AM sudando, corazón acelerado, mente en trabajo. ¿Cuántas
              noches más pierdes así?"
            </p>
          </motion.div>
        </div>

        {/* Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.4
      }} className="flex-1 relative flex flex-col items-center" data-id="element-49">
          <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl border border-forest-500/30" data-id="element-50">
            <img src="https://cdn.magicpatterns.com/uploads/naQ9eDotrK5jzXeT8HYEp5/mockup-1.png" alt="Plantas Mexicanas para Dormir Profundo eBook en varios dispositivos" className="w-full h-auto object-cover" data-id="element-51" />
          </div>
          {/* Glow behind image */}
          <div className="absolute inset-0 bg-gold-500 blur-[80px] opacity-20 -z-10 rounded-full transform scale-75" data-id="element-52" />

          {/* CTA below mockup */}
          <div className="mt-5 md:mt-8 text-center w-full" data-id="element-53">
            <a href="#pricing" className="inline-block bg-gold-500 hover:bg-gold-400 text-forest-900 font-bold text-lg px-8 py-4 rounded-lg shadow-[0_0_20px_rgba(212,168,67,0.3)] hover:shadow-[0_0_30px_rgba(212,168,67,0.5)] transition-all transform hover:-translate-y-1" data-id="element-54">
              QUIERO DORMIR PROFUNDO →
            </a>
            <p className="mt-3 text-sm text-cream-300/60" data-id="element-55">
              Acceso inmediato • PDF + Audio Guía
            </p>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1,
      y: [0, 10, 0]
    }} transition={{
      delay: 2,
      duration: 2,
      repeat: Infinity
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 text-gold-500/50" data-id="element-56">
        <ArrowDown className="w-8 h-8" data-id="element-57" />
      </motion.div>
    </section>;
}